import {AREA_UNITS, DISTANCE_UNITS} from '@src/constants/measureUnits.ts';

export const identity = (x: number) => x;

// ------------------------------------
// Distance

export const metersToFeet = (meters: number) => meters * 3.28084;
export const metersToKilometers = (meters: number) => meters / 1000;
export const metersToMiles = (meters: number) => meters / 1609.34;
export const metersToNauticalMiles = (meters: number) => meters / 1852;

export const feetToMeters = (feet: number) => feet / 3.28084;
export const kilometersToMeters = (kilometers: number) => kilometers * 1000;
export const milesToMeters = (miles: number) => miles * 1609.34;
export const nauticalMilesToMeters = (miles: number) => miles * 1852;

// ------------------------------------
// Area

export const sqmToAcres = (sqm: number) => sqm * 0.00024711;
export const sqmToHectares = (sqm: number) => sqm / 10_000;
export const sqmToSquareFeet = (sqm: number) => sqm * 10.764;
export const sqmToSquareKilometers = (sqm: number) => sqm / 1_000_000;
export const sqmToSquareMiles = (sqm: number) => sqm / 2.59e6;
export const sqmToSquareNauticalMiles = (sqm: number) => sqm / 3.43e6;

export const acresToSqm = (acres: number) => acres / 0.00024711;
export const hectaresToSqm = (hectares: number) => hectares * 10_000;
export const squareFeetToSqm = (sqft: number) => sqft / 10.764;
export const squareKilometersToSqm = (sqkm: number) => sqkm * 1_000_000;
export const squareMilesToSqm = (sqMiles: number) => sqMiles * 2.59e6;
export const squareNauticalMilesToSqm = (sqMiles: number) => sqMiles * 3.43e6;

// ------------------------------------
// Area

export const CONVERSION_MAP = {
  distance: {
    fromMeters: {
      [DISTANCE_UNITS.metric.m as string]: identity,
      [DISTANCE_UNITS.metric.km as string]: metersToKilometers,
      [DISTANCE_UNITS.usc.ft as string]: metersToFeet,
      [DISTANCE_UNITS.usc.mi as string]: metersToMiles,
      [DISTANCE_UNITS.usc.nmi as string]: metersToNauticalMiles,
    },
    toMeters: {
      [DISTANCE_UNITS.metric.m as string]: identity,
      [DISTANCE_UNITS.metric.km as string]: kilometersToMeters,
      [DISTANCE_UNITS.usc.ft as string]: feetToMeters,
      [DISTANCE_UNITS.usc.mi as string]: milesToMeters,
      [DISTANCE_UNITS.usc.nmi as string]: nauticalMilesToMeters,
    },
  },
  area: {
    fromSqm: {
      [AREA_UNITS.metric.ha as string]: sqmToHectares,
      [AREA_UNITS.metric.km2 as string]: sqmToSquareKilometers,
      [AREA_UNITS.metric.m2 as string]: identity,
      [AREA_UNITS.usc.ac as string]: sqmToAcres,
      [AREA_UNITS.usc.ft2 as string]: sqmToSquareFeet,
      [AREA_UNITS.usc.mi2 as string]: sqmToSquareMiles,
      [AREA_UNITS.usc.nmi2 as string]: sqmToSquareNauticalMiles,
    },
    toSqm: {
      [AREA_UNITS.metric.ha as string]: hectaresToSqm,
      [AREA_UNITS.metric.km2 as string]: squareKilometersToSqm,
      [AREA_UNITS.metric.m2 as string]: identity,
      [AREA_UNITS.usc.ac as string]: acresToSqm,
      [AREA_UNITS.usc.ft2 as string]: squareFeetToSqm,
      [AREA_UNITS.usc.mi2 as string]: squareMilesToSqm,
      [AREA_UNITS.usc.nmi2 as string]: squareNauticalMilesToSqm,
    },
  },
};
